import type { Faq, FaqGroup } from '../types/content';

export const homeFaqs: Faq[] = [
  {
    q: 'What do I need to bring?',
    a: 'A valid photo ID, your handgun (or rent one for $25), the ammunition listed for your course, water and a pen. Eye and ear protection are provided if you need them. Each course page lists exactly what to bring.',
  },
  {
    q: 'Can I rent a gun?',
    a: 'Yes. Rental handguns are available for $25 so you can train or qualify without owning a firearm yet. Just select the rental option when you book.',
  },
  {
    q: 'How long is the class?',
    a: 'The initial Multi-State CCW course is 8 hours (9am–6pm) plus range qualification. Nevada CCW renewal is 4 hours (9am–1pm) plus qualification. Defensive courses run 4 hours to 2 days.',
  },
  {
    q: 'Do I need experience?',
    a: 'No. Many of our students have never fired a gun. Our instructors coach you step by step, and we recommend starting with Introduction to Defensive Handgun if you are brand new.',
  },
  {
    q: 'Where are classes held?',
    a: 'Classroom sessions are held in the Conservation Room on the 2nd floor of Bass Pro Shops, 8200 Dean Martin Dr, Las Vegas, NV 89139 (Silverton Village). Range details are in your confirmation email.',
  },
  {
    q: 'Do you offer private training?',
    a: 'Yes — private 1-on-1 lessons, couples, families, corporate groups and organizations, scheduled 7 days a week around you.',
  },
];

export const ccwFaqs: Faq[] = [
  {
    q: 'Is Nevada a constitutional carry state?',
    a: 'No. Nevada requires a Concealed Firearms Permit to carry concealed. You must complete a sheriff-approved course and apply with a county sheriff.',
  },
  {
    q: 'Does my military or law-enforcement training count?',
    a: 'Out-of-state, military or law-enforcement training does not qualify on its own. You will need to complete a Nevada sheriff-approved course.',
  },
  {
    q: 'I don’t live in Nevada. Can I still get a permit?',
    a: 'Yes. Non-residents can take our course and apply with any Nevada county sheriff’s office.',
  },
  {
    q: 'When should I renew?',
    a: 'Nevada permits are valid for five years. Take the 4-hour renewal course within the renewal window before your permit expires.',
  },
  {
    q: 'What if I don’t pass the qualification?',
    a: 'Our instructors coach you through the qualification. If you need another attempt, we will work with you to get you there.',
  },
];

export const faqGroups: FaqGroup[] = [
  { title: 'Getting started', items: homeFaqs.slice(0, 4) },
  { title: 'Nevada CCW permits', items: ccwFaqs },
  {
    title: 'Classes & locations',
    items: [
      homeFaqs[4],
      homeFaqs[5],
      { q: 'Do you offer women-only classes?', a: 'Yes. Women-only classes taught by women have been part of HPP since 2013.' },
      { q: 'What days do you train?', a: 'We train 7 days a week, with around 50 classes scheduled every week.' },
    ],
  },
  {
    title: 'Booking & policies',
    items: [
      { q: 'How do I book?', a: 'Click any “Book” button to reserve your seat in our online store, or call (702) 375-5900.' },
      { q: 'Can I reschedule?', a: 'Yes, with advance notice. See our Refund Policy for details.' },
      { q: 'Do packages include private lessons?', a: 'Packages apply to group courses, not private sessions.' },
      { q: 'Do you sell gift certificates?', a: 'Yes. Gift certificates can be used for any course or package.' },
    ],
  },
];
